import { ExpandMore as ExpandMoreIcon } from "@mui/icons-material";
import clsx from "clsx";
import { useState } from "react";
import style from "./style.module.scss";

const SiteSelector = ({ currentSite, otherSites = [] }) => {
  const [openListSites, setOpenListSites] = useState(false);

  return !currentSite ? null : (
    <div
      className={style.siteSelector}
      onClick={() => setOpenListSites(!openListSites)}
    >
      <div className={style.currentSite}>
        <div className={style.site}>
          {currentSite.flag && (
            <div className={style.imgContainer}>
              <img
                src={currentSite.flag}
                alt={`Flag of ${currentSite.country}`}
                loading="lazy"
              />
            </div>
          )}

          <div className={style.country}>{currentSite.country}</div>
        </div>

        <ExpandMoreIcon
          className={clsx(style.expandMore, openListSites && style.rotate)}
        />
      </div>

      <div className={clsx(style.listSites, openListSites && style.open)}>
        {otherSites.map((site) => (
          <a href={site.link} key={site.link} className={style.site}>
            {site.flag && (
              <div className={style.imgContainer}>
                <img
                  src={site.flag}
                  alt={`Flag of ${site.country}`}
                  loading="lazy"
                />
              </div>
            )}

            <div className={style.country}>{site.country}</div>
          </a>
        ))}
      </div>
    </div>
  );
};

export default SiteSelector;
